module.exports = __webpack_public_path__ + "static/img/eredin_bringer.a4a2c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/eredin_bringer.png
// module id = rXb4
// module chunks = 0